import { TreatmentCalculator } from './TreatmentCalculator';

export class ExclusiveTreatmentCalculator extends TreatmentCalculator {
  constructor() {
    super();
  }
}
